import BaseService from '../BaseService'
import axios from "axios";

class BgRemovalService extends BaseService {
    constructor() {
        super('/bg-removal');
    }

    store ({ payload }) {
        return axios.post(`${this.resource}`, payload, {
            responseType: 'arraybuffer'
        })
    }

}

export default new BgRemovalService()
